import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=22d7c8e7&scoped=true&"
import script from "./Compass.vue?vue&type=script&lang=ts&"
export * from "./Compass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7c8e7",
  null
  
)

export default component.exports